<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  /deep/ .van-overlay {
    background-color: rgba(0, 0, 0, 0.3);
  }
  /deep/.van-dialog__header {
    font-weight: bold !important;
    font-size: 16px;
  }
  /deep/.van-dialog__message {
    font-size: 14px !important;
    margin: 14px 0 0 0;
    color: #333 !important;
    padding: 0 0 21px 0 !important;
  }
  // /deep/.van-button__text {
  //   font-size: 16px;
  //   color: #ff8300;
  // }
  /deep/ .van-dialog__cancel,
  .van-dialog__confirm {
    border-top: 1px solid #ccc !important;
    border-right: 1px solid #ccc !important;
  }
}
</style>
